module.exports = __webpack_public_path__ + "media/mypage/images/icon-configure-09762c9b46608425227d3840eb28237a.png";